import type { InjectionKey } from 'vue';
type TranslationFunction<P extends any[] = []> = (...args: P) => string;
type Translation<P extends any[] = []> = TranslationFunction<P> | string;
export interface UiConfig {
  i18n: {
    dataTable: {
      columnsSettingsTitle: Translation;
      columnsSettingsSearchHint: Translation;
      openColumnsSettings: Translation;
      noData: Translation;
      itemsSelected: Translation<[count: number]>;
      selectAllItems: Translation<[count: number]>;
      clearSelection: Translation;
      sortAscending: Translation;
      sortDescending: Translation;
      pinColumn: Translation;
      unpinColumn: Translation;
      hideColumn: Translation;
      filterByColumn: Translation;
      askAi: Translation;
    };
  };
}
export const defaultUiConfig: UiConfig = {
  i18n: {
    dataTable: {
      columnsSettingsTitle: 'Select columns to display',
      columnsSettingsSearchHint: 'Search columns',
      openColumnsSettings: 'Open columns visibility settings',
      noData: 'No data',
      itemsSelected: (count) => `${count} items selected`,
      selectAllItems: (count: number) => `Select all ${count} items`,
      clearSelection: 'Clear selection',
      sortAscending: 'Sort ascending',
      sortDescending: 'Sort descending',
      pinColumn: 'Pin column',
      unpinColumn: 'Unpin column',
      hideColumn: 'Hide column',
      filterByColumn: 'Filter by column',
      askAi: 'Ask AI',
    },
  },
};
export const UI_CONFIG_INJECTION_KEY: InjectionKey<UiConfig> = Symbol(__DEV__ ? 'UiConfig' : '');
